module.exports = __webpack_public_path__ + "static/media/bg-left-img-4.36c4957a.jpg";